// extracted by mini-css-extract-plugin
export default {"image":"QX-z","loaded":"RX-z"};